import React from "react";
import {
  DocumentData,
  WithFieldValue,
  addDoc,
  collection,
  doc,
  setDoc,
} from "firebase/firestore";

import { FirebaseContext } from "@contexts";

/**
 * A abstraction for Firestore that allows the user to create new documents.
 * This is meant to be wrapped by a `useCreate<CollectionDocument>` hook.
 * @returns An object with a `create` callback to make a new document.
 */
function useCreateDocument() {
  const { firestore } = React.useContext(FirebaseContext);

  const createDocument = React.useCallback(
    function createDocumentCallback<T extends WithFieldValue<DocumentData>>(
      collectionName: string,
      data: T,
      docId?: string,
    ) {
      if (docId) {
        const ref = doc(firestore, collectionName, docId);
        return setDoc(ref, data);
      } else {
        return addDoc(collection(firestore, collectionName), data);
      }
    },
    [firestore],
  );

  return { create: createDocument };
}

export { useCreateDocument };
